module.exports = __webpack_public_path__ + "static/media/45_A.8bb9de86.png";